// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedOctScanSize_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6.47485 16.1106 4.70709 14.3429 3.99998 19.9997 9.65683 19.2926 7.88907 17.5249 11.8379 13.576 10.4237 12.1618 6.47485 16.1106ZM19.2928 9.65712 17.525 7.88935 13.5762 11.8382 12.162 10.424 16.1108 6.47514 14.343 4.70737 19.9999 4.00026 19.2928 9.65712Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0V24H24V0H0ZM22 2H2V22H22V2Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedOctScanSize is a generated icon component.
 */
let IconMedOctScanSize = IconMedOctScanSize_1 = class IconMedOctScanSize extends IconBaseElement {
    render() {
        return html `${IconMedOctScanSize_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedOctScanSize.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedOctScanSize = IconMedOctScanSize_1 = __decorate([
    customElement('zui-icon-med-oct-scan-size')
], IconMedOctScanSize);
export { IconMedOctScanSize };
